module.exports = __webpack_public_path__ + "static/media/policy_documents_add.136447e2.svg";